import Skeleton from './skeleton';
export default Skeleton;
